<script setup lang="ts">
import { computed, ref } from 'vue';
import Menu from '@/components/AppMenu.vue';
import { useRouter } from 'vue-router';
import { useKeycloak } from '@dsb-norge/vue-keycloak-js';

const router = useRouter();

const menuVisible = ref(false);

defineProps<{
  homeRoute?: boolean;
}>();

const logout = () => {
  const keycloak = useKeycloak();
  const logoutUrl = keycloak.createLogoutUrl!();
  window.location.href = logoutUrl;
};

const isHomeRoute = computed(() => {
  return router.currentRoute.value.path === '/';
});
</script>
<template>
  <header
    class="z-20 w-full flex items-center justify-between py-[54px] px-4 md:px-24 lg:px-40"
    :class="{
      'absolute top-0 bg-gradient-to-b from-black/60 to-black/0': homeRoute
    }"
  >
    <div class="flex items-center gap-7">
      <img src="/lumar-logo.png" @click="router.push('/')" alt="lumar-logo" class="h-12 w-12" />
      <Button
        @click="router.push('/contacts')"
        :class="homeRoute ? 'text-white!' : 'text-lumar-gray!'"
        icon="pi pi-phone"
        variant="text"
        rounded
        aria-label="close"
      />
    </div>
    <div class="gap-8 hidden min-[1300px]:flex">
      <router-link
        to="/lumar-activities"
        class="text-sm font-semibold"
        :class="isHomeRoute ? 'text-white!' : 'text-lumar-gray!'"
      >
        Lumar aktivnosti
      </router-link>
      <router-link
        to="/color-palette"
        class="text-sm font-semibold"
        :class="isHomeRoute ? 'text-white!' : 'text-lumar-gray!'"
      >
        Barvna paleta hiše
      </router-link>
      <router-link
        to="/color-palette"
        class="text-sm font-semibold"
        :class="isHomeRoute ? 'text-white!' : 'text-lumar-gray!'"
      >
        Nasveti za gradnjo
      </router-link>
      <router-link
        to="/recommendations"
        class="text-sm font-semibold"
        :class="isHomeRoute ? 'text-white!' : 'text-lumar-gray!'"
      >
        Priporočajte nas
      </router-link>
    </div>
    <div class="flex items-center gap-4">
      <Button
        :class="homeRoute ? 'text-white!' : 'text-lumar-gray!'"
        icon="pi pi-cog"
        variant="text"
        rounded
        aria-label="close"
        @click="router.push({ path: '/settings' })"
      />
      <div class="min-[1300px]:hidden">
        <Button
          @click="menuVisible = !menuVisible"
          :class="homeRoute ? 'text-white!' : 'text-lumar-gray!'"
          icon="pi pi-bars"
          variant="text"
          rounded
          aria-label="close"
        />
      </div>
      <div class="hidden min-[1300px]:block">
        <Button
          @click="logout()"
          :class="homeRoute ? 'text-white!' : 'text-lumar-gray!'"
          icon="pi pi-sign-out"
          variant="text"
          rounded
          aria-label="close"
        />
      </div>
      <Menu v-model="menuVisible" />
    </div>
  </header>
</template>
